import * as React from 'react';
import {Alert} from 'antd';

import {InventoryStock} from '../api/dtos/dtos';
import locales from '../locales';
import {formatDateTimeOrNull} from '../utils/date-utils';
import {groupNumber, renderFixedPriceColumn} from "../utils/number-utils";

interface Props {
  stock: InventoryStock;
}

class InventoryStockDetailsAlert extends React.Component<Props, {}> {

  public render(): React.ReactNode {
    const {stock} = this.props;
    const content = (
      <table>
        <tbody>
        {this.row(locales.item_number, stock.inventoryNumber)}
        {this.row(locales.name, stock.name)}
        {this.row(locales.brand, stock.brand)}
        {this.row(locales.type, stock.type)}
        {this.row(locales.created_at, formatDateTimeOrNull(stock.createdAt))}
        {this.row(locales.infinite_stock, stock.infiniteStock ? locales.yes : locales.no)}
        {this.row(locales.available_count, stock.infiniteStock ? '' : `${groupNumber(stock.availableCount ?? 0)} ${locales.pcs}`)}
        {stock.infiniteStock && stock.infiniteStockCost && stock.infiniteStockProfitMargin &&
          this.row(locales.selling_price, renderFixedPriceColumn(stock.infiniteStockCost * ((stock.infiniteStockProfitMargin / 100) + 1)))}
        </tbody>
      </table>
    );

    return (
      <Alert
        style={{width: '50%', margin: '4px auto 24px'}}
        message={content}
        type="info"
      />
    );
  }

  private row = (title: string, value?: React.ReactNode): React.ReactNode => {
    if (!value) {
      return null;
    }

    return (
      <tr>
        <td style={{textAlign: 'right', paddingRight: 8, verticalAlign: 'top'}}><b>{title}</b></td>
        <td>{value}</td>
      </tr>
    );
  };
}

export default InventoryStockDetailsAlert;




// WEBPACK FOOTER //
// ./src/inventory-stock-details/InventoryStockDetailsAlert.tsx